/**
 * Salesforce export types shared between frontend and backend
 */

export type SalesforceExportObject = 'Contact' | 'Lead';

/**
 * How a Salesforce contact export links contacts to accounts.
 * Mirrors AccountAssociationMode in @edulead/utils, which the review step reads.
 */
export enum AccountAssociationMode {
  /** District (else agency, else school) is primary; the rest are linked indirectly. */
  MULTIPLE = 'MULTIPLE',
  /** The school when known, else the district. Other institutions are not linked. */
  SINGLE = 'SINGLE'
}

// For HubSpot exports (keeping here for consistency)
export enum ContactsWithoutCompaniesBehavior {
  IMPORT_ANYWAY = 'IMPORT_ANYWAY',
  SKIP = 'SKIP',
  CREATE_COMPANY_AND_IMPORT = 'CREATE_COMPANY_AND_IMPORT'
}